'use client';

import KeyIconsSection from './key-icons-section';
import KeyMainSection from './key-main-section';
import KeyTitle from './key-title';
import cx from 'classnames';
import styles from './product-list-key.module.scss';

type ProductListKeyProps = {
  isProductVariant?: boolean;
};

const ProductListKey = ({ isProductVariant = false }: ProductListKeyProps) => {
  return (
    <>
      <KeyTitle />
      <div
        className={cx('d-md-flex mt-2 pt-3 gap-4', styles['product-list-key'])}
      >
        <KeyMainSection isProductVariant={isProductVariant} />
        <KeyIconsSection />
      </div>
    </>
  );
};

export default ProductListKey;
